
import React from 'react';
import { commonOverlayStyle } from './overlayStyles';

const ScreenshotWarning = ({ setScreenshotDetected }) => {
  return (
    <div style={commonOverlayStyle}>
      <h3>Screenshot attempt detected! This action is not allowed during the interview.</h3>
      <div 
        onClick={() => setScreenshotDetected(false)} 
        style={{
          background: '#fff',
          padding: '6px 20px',
          borderRadius: 6,
          color: '#000',
          fontSize: 14,
          cursor: 'pointer'
        }}
      >
        Close
      </div>
    </div>
  );
};

export default ScreenshotWarning;